var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackagingPlantRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 1.75098C11.3696 1.75408 8.84927 2.79727 6.98997 4.65189C5.13068 6.5065 4.08516 9.02063 4.08203 11.6437C4.08203 19.8626 12.5941 27.4178 13.9988 27.4178C15.4034 27.4178 23.9155 19.862 23.9155 11.6437C23.9124 9.02088 22.8667 6.50669 21.0076 4.65189C19.1484 2.79709 16.6282 1.75409 13.9988 1.75098H13.9987ZM13.9987 7.09825C15.136 7.09825 16.2268 7.54894 17.0308 8.35128C17.8351 9.15337 18.2869 10.2415 18.2869 11.3761C18.2869 12.5107 17.8351 13.5988 17.0308 14.4008C16.2268 15.2032 15.136 15.6539 13.9987 15.6539C12.8614 15.6539 11.7706 15.2032 10.9666 14.4008C10.1623 13.5988 9.71052 12.5107 9.71052 11.3761C9.71219 10.2419 10.1645 9.15478 10.9682 8.35293C11.772 7.55108 12.8618 7.0999 13.9987 7.09825Z",
    fill: "#FF2828"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.16602,
    y: 7.00098,
    width: 11.6667,
    height: 9.91673,
    fill: "#FF2828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0474 10.7317L13.9124 6.99715C13.8324 6.9388 13.736 6.90723 13.637 6.90723C13.538 6.90723 13.4415 6.9388 13.3616 6.99715L8.22657 10.7317C8.10591 10.8199 8.03474 10.9604 8.03516 11.1098V17.6453C8.03516 17.7691 8.08434 17.8879 8.17187 17.9754C8.2594 18.0629 8.37819 18.1121 8.50198 18.1121H9.90243V13.9108C9.90243 13.787 9.95162 13.6682 10.0391 13.5807C10.1267 13.4931 10.2455 13.4439 10.3693 13.4439H16.9047C17.0285 13.4439 17.1473 13.4931 17.2348 13.5807C17.3223 13.6682 17.3715 13.787 17.3715 13.9108V18.1121H18.772C18.8958 18.1121 19.0146 18.0629 19.1021 17.9754C19.1896 17.8879 19.2388 17.7691 19.2388 17.6453V11.1098C19.2392 10.9604 19.168 10.8199 19.0474 10.7317ZM14.5707 11.5767H12.7034C12.5366 11.5767 12.3825 11.4877 12.2992 11.3433C12.2158 11.1988 12.2158 11.0209 12.2992 10.8764C12.3825 10.732 12.5366 10.643 12.7034 10.643H14.5707C14.7375 10.643 14.8916 10.732 14.975 10.8764C15.0584 11.0209 15.0584 11.1988 14.975 11.3433C14.8916 11.4877 14.7375 11.5767 14.5707 11.5767Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 14.3779H16.4378V15.7784H10.8359V14.3779Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 16.7119H16.4378V18.1124H10.8359V16.7119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagingPlantRemove);
export default __webpack_public_path__ + "static/media/packaging-plant-remove.def0fe3284a9908117f7045d563c92eb.svg";
export { ForwardRef as ReactComponent };